<mat-toolbar class="ori-elevation-z4 header">
  <mat-icon class="icon-left" svgIcon="graph"></mat-icon>
  <h3>{{ "maint.folder.create" | translate }}</h3>
  <mat-icon class="icon icon-close" (click)="close()" color="primary" svgIcon="close"></mat-icon>
</mat-toolbar>

<div class="content">
  <div class="section">
    <div class="label">{{ "pym.depth" | translate }} ({{ maxDepth }})</div>
    <mat-slider class="slider" [min]="1" [max]="5" [step]="1" [discrete]="true" [showTickMarks]="true">
      <input matSliderThumb [(ngModel)]="maxDepth" />
    </mat-slider>
  </div>
  <div class="section">
    <div class="label">{{ "maint.folder.maxDM" | translate }} ({{ maxDM }})</div>
    <mat-slider class="slider" [min]="0" [max]="1000" [step]="10" [discrete]="true">
      <input matSliderThumb [(ngModel)]="maxDM" />
    </mat-slider>
  </div>
</div>

<div mat-dialog-actions>
  <div class="action-buttons">
    <button (click)="submit()" class="btn-state" mat-button-raised color="primary" mat-raised-button="">
      <span class="mat-button-wrapper">{{ "pym.action" | translate }}</span>
      <div class="mat-button-ripple mat-ripple" mat-ripple=""></div>
      <div class="mat-button-focus-overlay"></div>
    </button>
  </div>
</div>
